import Arrow from "./arrow";
import Button from "./button";

export default function ButtonDownload(props) {
    const { children } = props;

    return <Button { ...props } className="button--change" rightIcon={<i class="ri-printer-line" style={{ fontSize: '22px' }}></i>}>{ children ? children : 'Download' }</Button>
}